module.exports = __webpack_public_path__ + "img/logo événement.7278f1d7.png";